import { ChatsComponent } from './chats.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/auth/auth.guard';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'chat/:chatId',
        canActivate: [AuthGuard],
        component: ChatsComponent,
      }
    ])
  ],
  exports: [RouterModule]
})
export class ChatsRoutingModule { }



// WEBPACK FOOTER //
// /ng-app/src/app/chats/chats.routing.module.ts